import PropTypes from "prop-types"
import React from "react"
import { Container, Row } from "reactstrap"
import { withTranslation } from "react-i18next"
import LoginActivityTable from "./LoginActivityTable"

const LoginActivity = () => {
  document.title = "Login Activity | CurbDash"
  const user = JSON.parse(localStorage.getItem("authUser"))

  // The API is the real gate — it answers 401 to every non-admin. This check only
  // avoids showing an admin-looking page that could never load any data.
  const isAdmin = user?.role === "admin"

  return (
    <React.Fragment>
      <div
        className="page-content"
        style={{ marginTop: -70, backgroundColor: "rgb(38, 37, 35)" }}
      >
        <Container fluid>
          <Row>
            {isAdmin ? (
              <LoginActivityTable token={user.token} />
            ) : (
              <div className="alert alert-warning">
                Login activity is available to administrators only.
              </div>
            )}
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}

LoginActivity.propTypes = {
  t: PropTypes.any,
}

export default withTranslation()(LoginActivity)
